'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { CDPSectionSkeleton } from '@src/app/app/[country]/[lang]/programs/[slug]/_components/skeletons/CDPSectionSkeleton';
import { useContentDetailsData } from '@src/hooks/useContentDetailsData';
import { buildContentDetailsSectionRedirectPath, isCdpContent } from '@src/mappers/content/content-section.mapper';
interface CdpRootRedirectProps {
  country: string;
  lang: string;
}
export function CdpRootRedirect(t0) {
  const $ = _c(8);
  const {
    country,
    lang
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    content
  } = useContentDetailsData();
  const startedRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== content || $[1] !== country || $[2] !== lang || $[3] !== router || $[4] !== searchParams) {
    t1 = () => {
      if (!content || !isCdpContent(content) || startedRef.current) {
        return;
      }
      startedRef.current = true;
      const path = buildContentDetailsSectionRedirectPath({
        country,
        lang,
        content,
        videoGuid: searchParams.get("videoGuid"),
        videoSlug: searchParams.get("slug"),
        search: window.location.search
      });
      if (path) {
        router.replace(path, {
          scroll: false
        });
      }
    };
    t2 = [content, country, lang, router, searchParams];
    $[0] = content;
    $[1] = country;
    $[2] = lang;
    $[3] = router;
    $[4] = searchParams;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CDPSectionSkeleton />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}